import { supabase } from "../supabase-client";

export const getUserPredictions = async (userId: string) => {
  try {
    const { data, error } = await supabase
      .from("predictions")
      .select("*")
      .eq("user_id", userId)
      .order("created_at", { ascending: false });

    if (error) {
      console.error("Error fetching predictions:", error);
      return [];
    }

    return data?.map((p: any) => ({ ...p, user_email: "" })) || [];
  } catch (error) {
    console.log("Error getting user predictions: ", error);
  }
};
